import React from 'react';
import './css/MainPage.css';
//import {Outlet, Link } from 'react-router-dom';
import {checkLocalStorage} from './Common.js';

import keycloak from './myKeycloak.js';
import DocumentationPage from './DocumentationPage';

/*
* This is the main page component.  Simply displays what dependencies are needed by this project.
* Also has links to the Logged in page, the actual login link and the logout link.
*/
class MainPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			logoutUrl: props.logoutUrl	
		};

        // binded functions
		this.initKeycloak = this.initKeycloak.bind(this);
	}

	/******************************************************************************
	* Invokes init method from keycloak object.  This causes user to have to login via keycloak.
	******************************************************************************/
	initKeycloak() {
		keycloak.init({
			onLoad: 'login-required',
			redirectUri: process.env.REACT_APP_FRONT_END_LOG
        }).success(function() {
			// intentionally blank as the user gets routed to the LoggedInPage
        }).error(function(error) {
			// intentionally blank as the user gets routed to the LoggedInPage
        }).catch(function() {
			// intentionally blank as the user gets routed to the LoggedInPage
        });
	}
	  

	/***********************************************************
	* Component is loaded/mounted on the page. 
	***********************************************************/
	componentDidMount() {

        // simply log debug information.
        //console.log('[MainPage] componentDidMount() -> is user authenticated: ' + keycloak.authenticated);
        var localKC = checkLocalStorage();
        if (localKC !== null && localKC !== undefined) {
			console.log('[MainPage] componentDidMount() -> localKC from localStorage isn\'t null.');
        } else {
        	console.log('[MainPage] componentDidMount() -> localKC is either null or undefined -> ' + localKC);
        }
    }

	/***********************************************************
	* Component is unloaded/unmounted from the page.
	***********************************************************/
	componentWillUnmount() {
		// intentionally blank
	}

	toggleDocumentation = () => {
		this.setState(prevState => ({
		  showDocumentation: !prevState.showDocumentation,
		}));
	  }
	  
    /*****************************************************************
	* HTML to be rendered.	 
	* Has 3 links.  1 to have the user login.  The 2nd to have the user logout.  The 3rd is a link to a LoggedInPage component.
	* In addition to that it just displays what I used in this project, ie dependencies, to get it to work.
	* 
	* For more information on the Link tag see https://v5.reactrouter.com/web/api/Link
	* For more information on the Outlink tag see https://reactrouter.com/en/main/components/outlet
    *****************************************************************/
	render() {
		const { showDocumentation } = this.state;
	  
		return (
			<div>
				<div className="loginPage">
					<img src="sodasense_icon.png" alt="Logo" className='logo_picture'/>
					<button className="loginButton" onClick={() => this.initKeycloak()}>Είσοδος ή Εγγραφή</button>
				</div>
				<div className="documentationContainer">
					<DocumentationPage />
				</div>
				{/* Other components and content */}
			</div>
		  );
	  }
}
export default MainPage;
